import styled from "styled-components";

export const ContainerLogin = styled.section`
  .container__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2.25rem;
    height: 100vh;
  }

  h2 {
    font-size: var(--sz-title-2);
    text-align: center;
    margin-bottom: 1.625rem;
  }
`;
